import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
      ]
    },
    EventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
      ]
    },
    StartTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    EndTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    PlannedGuestCount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'},
      ]
    },
    SiteName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    SiteAddress: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    SiteCity: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    SiteState: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },   
    Notes: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'FirstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Event Start Time:*',
                options: [
                  { label: '6:00 AM', value: '06:00:00' },
                  { label: '6:30 AM', value: '06:30:00' },
                  { label: '7:00 AM', value: '07:00:00' },
                  { label: '7:30 AM', value: '07:30:00' },
                  { label: '8:00 AM', value: '08:00:00' },
                  { label: '8:30 AM', value: '08:30:00' },
                  { label: '9:00 AM', value: '09:00:00' },
                  { label: '9:30 AM', value: '09:30:00' },
                  { label: '10:00 AM', value: '10:00:00' },
                  { label: '10:30 AM', value: '10:30:00' },
                  { label: '11:00 AM', value: '11:00:00' },
                  { label: '11:30 AM', value: '11:30:00' },
                  { label: '12:00 PM', value: '12:00:00' },
                  { label: '12:30 PM', value: '12:30:00' },
                  { label: '1:00 PM', value: '13:00:00' },
                  { label: '1:30 PM', value: '13:30:00' },
                  { label: '2:00 PM', value: '14:00:00' },
                  { label: '2:30 PM', value: '14:30:00' },
                  { label: '3:00 PM', value: '15:00:00' },
                  { label: '3:30 PM', value: '15:30:00' },
                  { label: '4:00 PM', value: '16:00:00' },
                  { label: '4:30 PM', value: '16:30:00' },
                  { label: '5:00 PM', value: '17:00:00' },
                  { label: '5:30 PM', value: '17:30:00' },
                  { label: '6:00 PM', value: '18:00:00' },
                  { label: '6:30 PM', value: '18:30:00' },
                  { label: '7:00 PM', value: '19:00:00' },
                  { label: '7:30 PM', value: '19:30:00' },
                  { label: '8:00 PM', value: '20:00:00' },
                  { label: '8:30 PM', value: '20:30:00' },
                  { label: '9:00 PM', value: '21:00:00' },
                  { label: '9:30 PM', value: '21:30:00' },
                  { label: '10:00 PM', value: '22:00:00' },
                  { label: '10:30 PM', value: '22:30:00' },
                  { label: '11:00 PM', value: '23:00:00' },
                  { label: '11:30 PM', value: '23:30:00' },
                  { label: '12:00 AM', value: '00:00:00' },
                  { label: '12:30 AM', value: '00:30:00' },
                  { label: '1:00 AM', value: '01:00:00' },
                  { label: '1:30 AM', value: '01:30:00' },
                  { label: '2:00 AM', value: '02:00:00' },
                  { label: '2:30 AM', value: '02:30:00' },
                  { label: '3:00 AM', value: '03:00:00' },
                  { label: '3:30 AM', value: '03:30:00' },
                  { label: '4:00 AM', value: '04:00:00' },
                  { label: '4:30 AM', value: '04:30:00' },
                  { label: '5:00 AM', value: '05:00:00' },
                  { label: '5:30 AM', value: '05:30:00' }
                ],
                mapping: 'StartTime'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Event End Time:*',
                options: [
                  { label: '6:00 AM', value: '06:00:00' },
                  { label: '6:30 AM', value: '06:30:00' },
                  { label: '7:00 AM', value: '07:00:00' },
                  { label: '7:30 AM', value: '07:30:00' },
                  { label: '8:00 AM', value: '08:00:00' },
                  { label: '8:30 AM', value: '08:30:00' },
                  { label: '9:00 AM', value: '09:00:00' },
                  { label: '9:30 AM', value: '09:30:00' },
                  { label: '10:00 AM', value: '10:00:00' },
                  { label: '10:30 AM', value: '10:30:00' },
                  { label: '11:00 AM', value: '11:00:00' },
                  { label: '11:30 AM', value: '11:30:00' },
                  { label: '12:00 PM', value: '12:00:00' },
                  { label: '12:30 PM', value: '12:30:00' },
                  { label: '1:00 PM', value: '13:00:00' },
                  { label: '1:30 PM', value: '13:30:00' },
                  { label: '2:00 PM', value: '14:00:00' },
                  { label: '2:30 PM', value: '14:30:00' },
                  { label: '3:00 PM', value: '15:00:00' },
                  { label: '3:30 PM', value: '15:30:00' },
                  { label: '4:00 PM', value: '16:00:00' },
                  { label: '4:30 PM', value: '16:30:00' },
                  { label: '5:00 PM', value: '17:00:00' },
                  { label: '5:30 PM', value: '17:30:00' },
                  { label: '6:00 PM', value: '18:00:00' },
                  { label: '6:30 PM', value: '18:30:00' },
                  { label: '7:00 PM', value: '19:00:00' },
                  { label: '7:30 PM', value: '19:30:00' },
                  { label: '8:00 PM', value: '20:00:00' },
                  { label: '8:30 PM', value: '20:30:00' },
                  { label: '9:00 PM', value: '21:00:00' },
                  { label: '9:30 PM', value: '21:30:00' },
                  { label: '10:00 PM', value: '22:00:00' }
                ],
                mapping: 'EndTime'
              }
            ]
          },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Service Type:* (Check all that apply)',
             options:[
              { label: 'Delivery'  , value: 'Delivery'},
              { label: 'Delivery plus setup'  , value: 'Delivery plus setup'},
              { label: 'Rentals Needed'  , value: 'Rentals Needed'},
              { label: 'Full Catering Service'  , value: 'Full Catering Service'},
            ],
            mapping: 'Theme'
          }
        ]
      },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Estimated Guest Count:*',
                mapping: 'PlannedGuestCount'
              }
            ]
          },
          {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Location:*',
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Address:*',
            mapping: 'SiteAddress'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event City:*',
            mapping: 'SiteCity'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event State:*',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'SiteState'
         }
        ]
      },
          {
            fields: [
              {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:*',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'El Cholo Catering Contact Form',
    formId: '2145',
    clientKey: 'E03846DB-8BCA-42C2-AC44-F996F424BD81',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
